import React, {Component} from 'react';
import {Modal, Button} from 'antd';

class ButtonConfirmDelete extends Component {
  confirm = () => {
    const {onOk, content, title, object} = this.props
    Modal.confirm({
      title: title,
      content: content,
      okText: 'Đồng ý',
      okType: 'danger',
      cancelText: 'Bỏ qua',
      onOk() {
        onOk(object)
      }
    });
  }
  render() {
    return (<span>
      <Button onClick={this.confirm} type="danger" ghost="ghost" size="small">
        Delete
      </Button>
    </span>);
  }
}

export default ButtonConfirmDelete;



// WEBPACK FOOTER //
// ./src/components/ButtonConfirmDelete.js